import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Segment } from '../../../../models/email-template/segment.interface';
import { segmentsForSelect } from '../../../../utils/segments-helper';

/**
 * Plain native <select> replacement for app-segment-dropdown (PrimeNG/Optimus
 * p-select), used only where [segmentSelectV2] is on (see block-text). The
 * mockup's own link+segment control is a native select merged flush against
 * the link input (see field-editor-v2's action-link styling) - a rich p-select
 * component can't produce that look (its own internal DOM/chrome resists the
 * border-merge + custom chevron), so this mirrors app-segment-dropdown's
 * Segment-object input/output contract with a native element instead.
 */
@Component({
  selector: 'app-segment-select-v2',
  imports: [CommonModule, FormsModule],
  templateUrl: './segment-select-v2.component.html',
  styleUrl: './segment-select-v2.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SegmentSelectV2Component implements OnInit {
  @Input() selectedSegment: Segment | undefined;
  @Output() selectedSegmentChange = new EventEmitter<Segment>();

  protected segments!: Segment[];

  ngOnInit(): void {
    this.segments = segmentsForSelect;
  }

  protected onChange(content: string): void {
    const segment = this.segments.find((s) => s.content === content);
    this.selectedSegmentChange.emit(segment);
  }
}
